<template lang="pug">
.nested-draggable-units
  draggable(
    v-model="units"
    tag="v-expansion-panels"
    handle=".handle"
    :group="draggable.group"
    :component-data="draggable.componentData"
    @change="$emit('change-unit-order', $event, units)"
  )
    template(v-for="(unit, index) in units")
      // Module row
      v-expansion-panel(
        v-if="unit.moduleItem"
      ).v-expansion-panel--outlined
        v-expansion-panel-header(color="secondary lighten-1" hide-actions).py-0
          v-list-item(class="handle")
            transition(name="drag-icon")
              v-list-item-action(v-if="editable" class="mr-0")
                v-icon.white--text mdi-drag
            v-list-item-content(
              style="width: 100px"
            ).ml-2
              v-list-item-title(
                class="course-unit__title"
              ).white--text.mb-1
                v-icon(size="60" color="grey lighten-5") mdi-school-outline
              v-list-item-content(
                class="course-unit__title"
              ).white--text {{ unit.moduleItem.name }}
              v-list-item-subtitle.grey--text
                | Количество тем - {{ unit.units.length }}
            v-list-item-action(v-if="editable")
              v-btn(
                @click.stop="detachModule(unit)"
                title="Удалить"
                fab
                x-small
                depressed
                color="white"
              )
                v-icon(color="red darken-2") mdi-delete-outline
        v-expansion-panel-content.mt-2
          v-list-item(
            v-for="(unit, idx) in unit.units"
            :key="unit.id"
          )
            v-list-item-content {{ unit.title }}

      unit-item(
        v-else
        :unit="unit"
        :canDeleteUnit="canDeleteUnit"
        :editable="editable"
        @deleted="$emit('deleted', $event)"
        @change-lesson-order="(val1, val2) => { changeLessonOrder(val1, val2, index) }"
        @deleteLesson="deleteLesson"
      )
</template>

<script>
import draggable from 'vuedraggable';
import UnitItem from './UnitItem.vue';

export default {
  name: 'UnitManagementDraggable',
  components: {
    draggable,
    UnitItem,
  },
  props: {
    value: { type: Array, default: () => ([]) },
    course: { type: Object, default: null },
    changeOrderEnable: { type: Function, default: () => {} },
    editable: { type: Boolean, default: false },
    canDeleteUnit: { type: Boolean, default: true },
  },
  data() {
    return {
      tab: null,
      unitId: null,

      deleteInstance: {},
      deleteUnitDialog: false,
      deleteLessonDialog: false,
      loadings: {
        progressLoading: {},
      },
      draggable: {
        group: {
          name: 'CourseUnitList',
        },
        subgroup: {
          name: 'CourseUnitListSub',
        },
        componentData: {
          on: {
            change: (arr) => this.$router
              .push({ query: { units: arr.length ? arr.join() : null } }),
          },
          props: {
            value: [],
            flat: true,
            multiple: true,
            hover: true,
            focusable: true,
          },
        },
      },
    };
  },
  computed: {
    units: {
      get() {
        return this.value;
      },
      set(val) {
        return this.$emit('input', val);
      },
    },
  },
  mounted() {
    this.draggable.componentData.props.value = this.$route.query.units?.split(',').map((i) => +i);
  },
  methods: {
    changeLessonOrder(moved, lessons, index) {
      this.$set(this.units[index], 'lessons', lessons);
      this.$emit('change-lesson-order', moved);
    },
    detachModule(item) {
      this.$modals.show('confirm-controller', {
        type: 'error',
        title: 'Удалить модуль',
        message: 'Модуль будет откреплен после чего вы сможете его снова добавить',
        method: async () => {
          await this.$api.modules.detach(
            item.moduleItem.id, { course_id: this.course.id },
          );
          this.$emit('deleted', item);
        },
      });
    },
    deleteLesson(lesson) {
      const unitIdx = this.units.findIndex(
        (i) => i.id === lesson.course_unit_id,
      );
      const lessons = this.units[unitIdx].lessons.filter(
        (l) => l !== lesson,
      );
      this.$set(this.units[unitIdx], 'lessons', lessons);
      this.deleteLessonDialog = false;
      this.deleteInstance = {};
    },
  },
};
</script>
